import { css } from "@emotion/react";

export const backupCodeInputWrapper = css`
  margin: 1rem 0;
  width: 100%;
`;

export const nextButton = css`
  margin-top: 1rem;
  margin-bottom: 3rem;
`;

export const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  max-width: 26rem;
  margin: 0 auto;
  text-align: center;
`;
